import useFeatureFlags from 'app/hooks/useFeatureFlags';

import CustomScrollbarV2 from './CustomScrollbarV2';
import CustomScrollbarV1, { CustomScrollbarProps } from './CustomScrollbarV1';

export default function CustomScrollbar(props: CustomScrollbarProps) {
  const { uiRefreshNativeScrollBar } = useFeatureFlags();

  if (uiRefreshNativeScrollBar) {
    return <CustomScrollbarV2 {...props} />;
  }

  return <CustomScrollbarV1 {...props} />;
}
